import { EvidenceServiceApiKey } from '@app/injectionKeys'
import { injectStrict } from '@app/utils/injectStrict'
import { Timeframe } from '@core/domain/types/timeframe.type'

export function useMedicalBackgroundPresetAssistant() {
  const evidenceService = injectStrict(EvidenceServiceApiKey)

  async function findConditionNames({
    conditionName,
  }: {
    conditionName: string
  }): Promise<string[]> {
    const { data } =
      await evidenceService.api.assistantsControllerFindConditionNames({
        conditionName,
      })
    return data
  }

  async function generateLevelOfEvidence({
    conditionNames,
    purpose,
  }: {
    conditionNames: string
    purpose: string
  }) {
    const { data } =
      await evidenceService.api.assistantsControllerGenerateLevelOfEvidence({
        conditionNames,
        purpose,
      })
    return data
  }

  async function determineTimeFrame({
    conditionNames,
    purpose,
  }: {
    conditionNames: string
    purpose: string
  }): Promise<Timeframe | undefined> {
    const { data } =
      await evidenceService.api.assistantsControllerDetermineTimeFrame({
        conditionNames,
        purpose,
      })
    return data
  }

  return {
    findConditionNames,
    generateLevelOfEvidence,
    determineTimeFrame,
  }
}

export function useNotifiedBodyPresetAssistant() {
  const evidenceService = injectStrict(EvidenceServiceApiKey)

  async function findDeviceGroupNames({
    deviceGroup,
  }: {
    deviceGroup: string
  }): Promise<string[]> {
    const { data } =
      await evidenceService.api.assistantsControllerFindDeviceGroupNames({
        deviceGroup,
      })
    return data
  }

  async function generateLevelOfEvidence({
    deviceGroupNames,
  }: {
    deviceGroupNames: string
  }) {
    const { data } =
      await evidenceService.api.assistantsControllerGenerateLevelOfEvidenceForDeviceGroup(
        {
          deviceGroupNames,
        },
      )
    return data
  }

  async function determineTimeFrame({
    deviceGroupNames,
  }: {
    deviceGroupNames: string
  }): Promise<Timeframe | undefined> {
    const { data } =
      await evidenceService.api.assistantsControllerDetermineTimeFrameForDeviceGroup(
        {
          deviceGroupNames,
        },
      )
    return data
  }

  return {
    findDeviceGroupNames,
    generateLevelOfEvidence,
    determineTimeFrame,
  }
}
